import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorSelectPopup from "./PapersGeneratorSelectPopup";
import Endpoints from "constants/Endpoints";
import PropTypes from "prop-types";
import useSnackbar from "hooks/useSnackbar";

const PapersGeneratorMessageFilesVerification = (
    {
        demandId,
        paper,
        onClose,
        shareSystem
    }) => {

    const [invitedSuppliers, setInvitedSuppliers] = useState(null);
    const [working, setWorking] = useState(false);
    const {enqueueSuccessSnackbar} = useSnackbar();

    useEffect(() => {
        PapersGeneratorService.getRfxInvitedSupplierWithOffer(demandId).then(resp => setInvitedSuppliers(resp));
    }, [demandId])

    const generateClick = (supplier) => {
        setWorking(true);
        const url = Endpoints.PAPERS_GENERATOR_CORRESPONDENCE_ATTACHMENT_VERIFICATION_REPORT(demandId) + `?cdId=ris_${supplier.id}`;

        if (shareSystem) {
            PapersGeneratorService.sharePaperByUrl(url, shareSystem).then(resp => resp ? enqueueSuccessSnackbar(Tr("int_upload_success_x", {x: shareSystem}, true)) : null).finally(() => setWorking(false));
        } else {
            PapersGeneratorService.downloadPaper(url, () => setWorking(false), () => setWorking(false))
        }
    }
    return (
        <PapersGeneratorSelectPopup
                onClose={onClose}
                paperId={paper.paperId}
                title={Tr('choose_supplier')}
                list={invitedSuppliers}
                onSelect={generateClick}
                selectGeneratesDocument
                working={working}
        />
    )
}
PapersGeneratorMessageFilesVerification.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}
export default PapersGeneratorMessageFilesVerification;